/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */
// You can delete this file if you're not using it
import { wrapPageElementWithBanner } from './scripts/wrapPageElement/wrapPageElement';

import './src/styles/index.scss';

// This is needed to not trigger CookieBanner rerendering on page change (the same is in gatsby-ssr.js)
export const wrapPageElement = wrapPageElementWithBanner;

// This is necessary when Gatsby always treats the link as initial
export const shouldUpdateScroll = ({ routerProps: { location } }) => {
  if (location.hash) {
    return true;
  }

  if (!location.key || location.key === 'initial') {
    window.scrollTo(0, 0);

    return false;
  }

  return true;
};
